import styled from 'styled-components';

import { Vertical } from 'atoms/layout/flex';
import { HeadlineS, LabelS } from 'atoms/typography';
import { splitName } from 'lib/players';

const Wrapper = styled(Vertical).attrs({ gap: 1 })`
  flex: 1;
  padding-top: calc(6 * var(--unit));
  width: 100%;
  color: var(--c-neutral-1000);
  overflow: hidden;
`;

const Name = styled(HeadlineS).attrs({ as: 'div' })`
  text-align: center;
  overflow: hidden;
  width: 100%;
`;

const TruncableText = styled.div`
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Positions = styled(LabelS).attrs({ as: 'div', bold: true })`
  text-align: center;
  text-transform: uppercase;
`;

export type Props = {
  displayName: string;
  position: string;
};

export const MissingCard = ({ displayName, position }: Props) => {
  const [firstName, lastName] = splitName(displayName);

  return (
    <Wrapper>
      <Name>
        <TruncableText>{firstName}</TruncableText>
        <TruncableText>{lastName}</TruncableText>
      </Name>
      <Positions>{position}</Positions>
    </Wrapper>
  );
};
